export default __webpack_public_path__ + "static/broadcastImg3-065f62d957edc0abcb58e08c452797de.webp";